import IBANFinder from "./module/IBANFinder";
import IBANChecker from "./module/IBANChecker";
import Calconstruction from "./module/CalcConstruction";
import CarFinance from "./module/CarFinance";
import SelfEmployed from "./module/SelfEmployed";
import Buyout from "./module/Buyout";
import SavingsPlanner from "./module/SavingsPlanner";
import RetirementPlanner from "./module/RetirementPlanner";
import HomeFinance from "./module/HomeFinance";
import EquatyRelease from "./module/EquityRelease";
import EquityRelease from "./module/EquityRelease";
import DebtCalculator from "./module/DebtCalculator";
import GoverSubsidyProgram from "./module/GovSubsidaryProgram";
import InstantFinance from "./module/InstantFinance";
import DeveloperPurchase from "./module/DeveloperPurchase";

//ADIB Forms
const ibanFinder = new IBANFinder("ibanFinders");
const ibanChecker = new IBANChecker("ibanCheckers");
const calculatormain = new Calconstruction("calculatormain");
const carFinance = new CarFinance("carFinance");
const savingsPlanner = new SavingsPlanner("savingsPlanner");
const homeFinance = new HomeFinance("homeFinance", "backdrop");
const buyout = new Buyout("buyout");
const selfEmployed = new SelfEmployed("selfEmployed");
const equity = new EquityRelease("equity");
const govSubsidyProgram = new GoverSubsidyProgram("govSubsidyProgram");
const retirementPlanner = new RetirementPlanner("retirement-planner-main");

const debtCalculator = new DebtCalculator("debtCalculator", "modalId", "backdrop");
const instantFinance = new InstantFinance("instantFinance");
const devPurchase = new DeveloperPurchase("devPurchase");
